
<template>
  <v-app id="searchGebr">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>ARES users</v-card-title>
      <v-simple-table dense>
         <thead>
           <tr>
             <td>Name</td>
             <td>Ares access</td>
             <td>Start date</td>
             <td>End date</td>
             <td>Function</td>
           </tr>  
         </thead>  
         <tbody v-for="(gebrRecord,i) in searchGebr" :key="i">
           <tr @click="$router.reload('/syst/ref/gebr/onGebr/' + gebrRecord.gebr_encrid)">
             <td>{{gebrRecord.gebr_naam}}</td>
             <td>{{gebrRecord.gebr_actief}}</td>
             <td>{{gebrRecord.gebr_indienst_dat}}</td>
             <td>{{gebrRecord.gebr_uitdienst_dat}}</td>
             <td>{{gebrRecord.gebr_functie}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchGebr: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/gebr/searchGebr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchGebr"
          },
          searchGebr: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchGebr = res.data.searchGebr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
